import { useState } from 'react';

import RadioGroup from '@/v2/components/Cards/RadioCard/RadioGroup';
import CheckboxCard from '@/v2/components/Cards/CheckboxCard/CheckboxCard';
import Text from '@/v2/components/Typography/Text';

export default function SurveyStepOptionsMultiple({
  options,
  size = 'default',
  children,
}) {
  const textVariant = size == 'compact' ? 'grey-14-semi' : 'dm-16-medium';
  const [selected, setSelected] = useState(new Set());

  const toggleSelection = (value) => {
    setSelected((prev) => {
      const updated = new Set(prev);
      if (updated.has(value)) {
        updated.delete(value);
      } else {
        updated.add(value);
      }
      return updated;
    });
  };
  return children({
    disabled: selected.size == 0,
    answers: Array.from(selected),
    content: (
      <RadioGroup variant="vertical" size={size}>
        {options.map((option) => (
          <CheckboxCard
            key={option.value}
            selected={selected.has(option.value)}
            onSelect={() => toggleSelection(option.value)}
            variant="horizontal"
            size={size}
            ariaLabel={option.label}
            testId={option.value}
          >
            <Text variant={textVariant} color="black">
              {option.label}
            </Text>
          </CheckboxCard>
        ))}
      </RadioGroup>
    ),
  });
}
